module.exports = __webpack_public_path__ + "img/LC.15e70613.svg";